module.exports = __webpack_public_path__ + "img/book-pages.72732005.svg";